<template>
  <div>
    <header class="game">
      <a style="cursor: pointer" class="logo_score" @click.prevent="goToHomePage">
        <img :src="getTranslations.project_logo_img" alt="">
      </a>
      <div class="player_section">
        <div class="name_points">
          <p class="name">{{ userDetails.username }}</p>
          <p class="points"><span>{{ userDetails.totalPointsEarned }} </span>{{ getTranslations.home_loader_points }}</p>
        </div>
        <div class="avatar">
          <img :src="userDetails.avatar">
        </div>
      </div>
    </header>
    <div class="container-fluid">
      <div class="row score_page">
        <div v-if="addOnMode.lostPointsForMissedAddOnGame" class="container postgame">
          <h1>{{ getTranslations.post_game_double_lose }}</h1>
          <h2>
            {{ getTranslations.post_game_score_double_points }}<br>
            {{ getTranslations.post_game_miss_lose_half }}
          </h2>

          <div class="game_section">
            <div class="header">
              <div class="points_block">
                <p class="label">{{ getTranslations.post_game_pay_out }}</p>
                <p class="points">{{ payOutPoints }} {{ getTranslations.post_game_points }}</p>
              </div>
              <div class="points_block">
                <p class="label">{{ getTranslations.post_game_at_risk }}</p>
                <p class="points">{{ riskPoints }} {{ getTranslations.post_game_points }}</p>
              </div>
            </div>
            <img src="static/penalty_kicks/sprites/bg_menu.png" class="iframe_cover">
            <button type="button" @click.prevent="goToAddOnGame">{{ getTranslations.post_game_play_now }}</button>
          </div>
        </div>
        <div v-else-if="!addOnMode.lostPointsForMissedAddOnGame && addOnMode.assignPointsAfterAddOnGame" class="container postgame">
          <h1>{{ getTranslations.post_game_double_points }}</h1>
          <h2>
            {{ getTranslations.post_game_score_double_points }}
          </h2>

          <div class="game_section">
            <div class="header">
              <div class="points_block">
                <p class="label">{{ getTranslations.post_game_pay_out }}</p>
                <p class="points">{{ payOutPoints }} {{ getTranslations.post_game_points }}</p>
              </div>
            </div>
            <img src="static/penalty_kicks/sprites/bg_menu.png" class="iframe_cover">
            <button type="button" @click.prevent="goToAddOnGame">{{ getTranslations.post_game_play_now }}</button>
          </div>
        </div>
        <div v-else class="container postgame">
          <h1>{{ getTranslations.post_game_bonus_game_won }}</h1>
          <h2>
            {{ getTranslations.post_game_score_penalty_enjoy }}
          </h2>

          <div class="game_section">
            <div class="header">
              <div class="points_block">
              </div>
            </div>
            <img src="static/penalty_kicks/sprites/bg_menu.png" class="iframe_cover">
            <button type="button" @click.prevent="goToAddOnGame">{{ getTranslations.post_game_play_now }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint no-console: "off" */
/* games_postgame_1-2-3.html */
import { mapGetters, mapState, mapMutations } from 'vuex';

export default {
  name: 'post-game-add-on',
  data() {
    return {
      totalEarnedPoints: 0,
      payOutPoints: 0,
      riskPoints: 0,
      gameId: null,
    };
  },
  created() {
    console.log('in PostGame created hook');
    if (!this.$route.params.gameId) this.$router.push('/home');
    this.gameId = this.$route.params.gameId;
    this.totalEarnedPoints = this.homePlayerTotalEarnedPoints;
    console.log('this.totalEarnedPoints:', this.totalEarnedPoints);
    this.pointsForPayOutAndRisk();
  },
  beforeRouteLeave(to, from, next) {
    console.log('==> inside component\'s beforeRouteLeave:');
    console.log(`from.path: ${from.path}`);
    console.log(`to.path: ${to.path}`);
    if (['/home', '/addOnGame'].includes(to.path)) next();
    else next({ path: '/home' });
  },
  methods: {
    ...mapMutations('game', [
      'setAddOnGameData',
    ]),
    goToHomePage() {
      this.$router.push('/home');
      window.location.reload();
    },
    goToAddOnGame() {
      this.$router.push({ name: 'addOnGame', params: { gameId: this.gameId } });
    },
    pointsForPayOutAndRisk() {
      if (this.addOnMode.lostPointsForMissedAddOnGame) {
        this.riskPoints = Math.floor(this.totalEarnedPoints / this.addOnMode.factor);
        this.payOutPoints = this.totalEarnedPoints * this.addOnMode.factor;
      } else if (!this.addOnMode.lostPointsForMissedAddOnGame) {
        this.riskPoints = 0;
        this.payOutPoints = this.totalEarnedPoints * this.addOnMode.factor;
      }
      const payload = {
        gameId: this.gameId, correctAnswers: this.$route.params.correctAnswers, riskPoints: this.riskPoints, payOutPoints: this.payOutPoints,
      };
      this.setAddOnGameData(payload);
    },
  },
  computed: {
    ...mapState('common', [
      'addOnMode',
      'userDetails',
    ]),
    ...mapState('game', [
      'homePlayerTotalEarnedPoints',
    ]),
    ...mapGetters('game', [
      'isHomePlayer',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/addongame/PostGameAddOn.vue